import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepAdminRecinto     from '../../components/recinto/StepAdminRecinto';
import StepDatosRecinto     from '../../components/recinto/StepDatosRecinto';
import StepCanchas          from '../../components/recinto/StepCanchas';
import StepServiciosRecinto from '../../components/recinto/StepServiciosRecinto';
import StepHorarios         from '../../components/recinto/StepHorarios';
import { registrarRecinto, registrarCancha, registrarUsuario } from '../../services/api';

const PASOS = [
  { num: 1, label: 'Cuenta'    },
  { num: 2, label: 'Recinto'   },
  { num: 3, label: 'Canchas'   },
  { num: 4, label: 'Servicios' },
  { num: 5, label: 'Horarios'  },
];

export default function RegistroRecinto() {
  const navigate   = useNavigate();
  const [paso,     setPaso]     = useState(1);
  const [datos,    setDatos]    = useState({});
  const [cargando, setCargando] = useState(false);
  const [error,    setError]    = useState('');

  const handleNext = (datosPaso) => {
    const actualizados = { ...datos, ...datosPaso };
    setDatos(actualizados);
    if (paso < 5) {
      setPaso(paso + 1);
    } else {
      finalizar(actualizados);
    }
  };

  const handleBack = () => {
    if (paso > 1) setPaso(paso - 1);
  };

  const finalizar = async (datosFinales) => {
  setCargando(true);
  setError('');
  try {
    // 1. Crear usuario administrador del recinto
    const usuarioRes = await registrarUsuario({
      nombre:   datosFinales.nombre,
      email:    datosFinales.email,
      password: datosFinales.password,
      celular:  datosFinales.celular,
      rol:      'recinto',
    });

    if (usuarioRes.error) {
      setError('Error al crear cuenta: ' + usuarioRes.error);
      setCargando(false);
      return;
    }

    const adminId = usuarioRes.usuario.id;

    // 2. Crear recinto
    const recinto = await registrarRecinto({
      nombre:       datosFinales.nombreRecinto,
      direccion:    datosFinales.direccion,
      ciudad:       datosFinales.ciudad       || null,
      zona:         datosFinales.zona,
      descripcion:  datosFinales.descripcion  || null,
      instagram:    datosFinales.instagram    || null,
      facebook:     datosFinales.facebook     || null,
      tiktok:       datosFinales.tiktok       || null,
      web:          datosFinales.web          || null,
      dias_activos: datosFinales.diasActivos  || [],
      apertura:     datosFinales.apertura,
      cierre:       datosFinales.cierre,
      servicios:    datosFinales.servicios    || [],
      admin_id:     adminId,
    });

    if (recinto.error) {
      setError('Error al crear recinto: ' + recinto.error);
      setCargando(false);
      return;
    }

    // 3. Crear canchas
    if (datosFinales.canchas?.length > 0) {
      for (const cancha of datosFinales.canchas) {
        await registrarCancha({
          recinto_id: recinto.id,
          nombre:     cancha.nombre || cancha.tipo,
          tipo:       cancha.tipo,
          superficie: cancha.superficie || null,
          precio:     cancha.precio,
          techada:    cancha.techada || false,
          horas_disponibles: cancha.horas_disponibles || [],
        });
      }
    }

    // 4. Redirigir al login con mensaje
    navigate('/login');

  } catch {
    setError('Error de conexión. Intenta de nuevo.');
  } finally {
    setCargando(false);
  }
};

  return (
    <div style={styles.pagina}>
      <div style={styles.container}>

        <div style={styles.logo}>
          Tu<span style={styles.logoSpan}>Rival</span>
          <span style={styles.logoSub}> · Recintos</span>
        </div>

        <div style={styles.stepper}>
          {PASOS.map(({ num, label }, i) => {
            const completado = paso > num;
            const activo     = paso === num;
            return (
              <div key={num} style={styles.stepItem}>
                <div style={{
                  ...styles.stepCirculo,
                  background: completado ? '#16A34A' : activo ? '#FF6B1A' : 'rgba(255,255,255,0.1)',
                  border: activo ? '2px solid #FF6B1A' : completado ? '2px solid #16A34A' : '2px solid rgba(255,255,255,0.15)',
                }}>
                  <span style={{
                    color: completado || activo ? 'white' : 'rgba(255,255,255,0.3)',
                    fontSize: 12, fontWeight: 700,
                    fontFamily: "'Barlow Condensed', sans-serif",
                  }}>
                    {completado ? '✓' : num}
                  </span>
                </div>
                <span style={{
                  fontSize: 10, fontWeight: 600,
                  color: activo ? 'white' : 'rgba(255,255,255,0.3)',
                  fontFamily: "'Barlow', sans-serif",
                  textTransform: 'uppercase', letterSpacing: '0.04em',
                }}>
                  {label}
                </span>
                {i < PASOS.length - 1 && (
                  <div style={{
                    ...styles.stepLinea,
                    background: completado ? '#16A34A' : 'rgba(255,255,255,0.1)',
                  }} />
                )}
              </div>
            );
          })}
        </div>

        {error && (
          <div style={styles.errorBanner}>{error}</div>
        )}

        <div style={styles.card}>
          {paso === 1 && <StepAdminRecinto datos={datos} onNext={handleNext} />}
          {paso === 2 && <StepDatosRecinto datos={datos} onNext={handleNext} onBack={handleBack} />}
          {paso === 3 && <StepCanchas datos={datos} onNext={handleNext} onBack={handleBack} />}
          {paso === 4 && <StepServiciosRecinto datos={datos} onNext={handleNext} onBack={handleBack} />}
          {paso === 5 && <StepHorarios datos={datos} onNext={handleNext} onBack={handleBack} cargando={cargando} />}
        </div>

        <p style={styles.linkEquipos}>
          ¿Eres capitán de un equipo?{' '}
          <span style={styles.link} onClick={() => navigate('/registro')}>
            Regístrate aquí
          </span>
        </p>

      </div>
    </div>
  );
}

const styles = {
  pagina: {
    minHeight: '100vh', background: '#0D1117',
    padding: '32px 20px',
    display: 'flex', alignItems: 'flex-start', justifyContent: 'center',
  },
  container: { width: '100%', maxWidth: 580 },
  logo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 28, fontWeight: 800,
    color: 'white', textAlign: 'center',
    marginBottom: 24, letterSpacing: '-0.02em',
  },
  logoSpan: { color: '#FF6B1A' },
  logoSub: { fontSize: 16, fontWeight: 500, color: 'rgba(255,255,255,0.3)' },
  stepper: {
    display: 'flex', alignItems: 'flex-start',
    justifyContent: 'center', marginBottom: 24, padding: '0 10px',
  },
  stepItem: {
    display: 'flex', flexDirection: 'column',
    alignItems: 'center', gap: 5,
    position: 'relative', flex: 1,
  },
  stepCirculo: {
    width: 32, height: 32, borderRadius: '50%',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', zIndex: 1, transition: 'all 0.2s',
  },
  stepLinea: {
    position: 'absolute', top: 16, left: '50%',
    width: '100%', height: 2, zIndex: 0, transition: 'background 0.2s',
  },
  errorBanner: {
    background: 'rgba(239,68,68,0.1)',
    border: '1px solid rgba(239,68,68,0.3)',
    borderRadius: 10, padding: '10px 16px',
    fontSize: 13, color: '#EF4444',
    fontFamily: "'Barlow', sans-serif",
    marginBottom: 16, textAlign: 'center',
  },
  card: {
    background: 'white', borderRadius: 20,
    padding: '32px', marginBottom: 16,
  },
  linkEquipos: {
    textAlign: 'center', fontSize: 13,
    color: 'rgba(255,255,255,0.3)',
    fontFamily: "'Barlow', sans-serif",
  },
  link: { color: '#1A6BFF', cursor: 'pointer', fontWeight: 600 },
};